/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgContactGroupPlus = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M9 4a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM4 7a5 5 0 1 1 10 0A5 5 0 0 1 4 7zm15 2a3 3 0 0 0-3-3V4a5 5 0 1 1-2.423 9.374l.97-1.748A3 3 0 0 0 19 9zM5.14 17.42C4.388 18.269 4 19.502 4 21v1H2v-1c0-1.817.47-3.584 1.645-4.908C4.84 14.748 6.64 14 9 14s4.16.748 5.355 2.092C15.53 17.416 16 19.183 16 21v1h-2v-1c0-1.499-.388-2.732-1.14-3.58C12.126 16.595 10.924 16 9 16s-3.126.594-3.86 1.42zM19 19v-2h2v2h2v2h-2v2h-2v-2h-2v-2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgContactGroupPlus as ContactGroupPlus };
